import { INTERACTION_SELECT_FEATURES, DELETE_FEATURES, DELETE_ALL_FEATURES, SET_MAP_DEFAULT_STATE, SET_INTERACTION, SET_LAYER_FEATURE_HIGHLIGHT, SET_SNAP_INTERACTION, SET_MAPBOX_FEATURE_STATE, } from '../constants';
import { getInitialState } from './initialState';
const initialState = getInitialState().interaction;
export const interaction = (state = initialState, action) => {
    switch (action.type) {
        case SET_MAP_DEFAULT_STATE: {
            return initialState;
        }
        case INTERACTION_SELECT_FEATURES: {
            return {
                ...state,
                selectedFeatureIds: action.payload.featureIds,
            };
        }
        case SET_INTERACTION: {
            return {
                ...state,
                ...action.payload,
                style: action.payload.style ?? initialState.style,
            };
        }
        case DELETE_FEATURES: {
            return {
                ...state,
                selectedFeatureIds: state.selectedFeatureIds.filter((selectedFeatureId) => {
                    return !action.payload.featureIds.find((featureId) => featureId === selectedFeatureId);
                }),
            };
        }
        case DELETE_ALL_FEATURES: {
            return {
                ...state,
                selectedFeatureIds: [],
            };
        }
        case SET_LAYER_FEATURE_HIGHLIGHT: {
            return {
                ...state,
                highlightedFeatures: action.payload.highlightedFeatures,
                coordinate: action.payload.coordinate ?? null,
            };
        }
        case SET_SNAP_INTERACTION: {
            return {
                ...state,
                snap: {
                    ...state.snap,
                    ...action.payload,
                },
            };
        }
        case SET_MAPBOX_FEATURE_STATE: {
            return {
                ...state,
                mapboxFeatureState: {
                    ...state.mapboxFeatureState,
                    ...action.payload,
                },
            };
        }
        default: {
            return state;
        }
    }
};
//# sourceMappingURL=interactionReducer.js.map